function scrollPopup() {
  let popups = $('.popups');
  let popupTimeouts = $('.popup-timeout');
  let popupScrollpages = $('.popup-scrollpage');

  // Обрабатываем все попапы с тайм-аутом
  popupTimeouts.each(function() {
    let popupTimeout = $(this);
    if (popupTimeout.attr('data-active') == 'on' && popupTimeout.attr('data-timeout') == 'on') {
      let isSetPopupTimeout = localStorage.getItem('popupTimeout') || 'notShowed';
      setTimeout(function() {
        if (isSetPopupTimeout !== 'showed') {
          popups.css('z-index', '1000');
          popupTimeout.addClass('active');
        }
      }, 20000);
      setTimeout(function() {
        if (isSetPopupTimeout !== 'showed') {
          popupTimeout.removeClass('active');
          popupTimeout.remove();
          popups.css('z-index', '-1');
          localStorage.setItem('popupTimeout', 'showed');
        }
      }, 35000);
    }
  });

  // Обрабатываем все попапы с появлением при скролле
  popupScrollpages.each(function() {
    let popupScrollpage = $(this);
    if (popupScrollpage.attr('data-active') == 'on' && popupScrollpage.attr('data-scrollpage') == 'on') {
      let isTimeoutSet = false;
      let isSetPopupScrollpage = localStorage.getItem('popupScrollpage') || 'notShowed';

      $(window).on('scroll', function() {
        let scrollPosition = $(window).scrollTop();
        let documentHeight = $(document).height();
        let windowHeight = $(window).height();

        if (!isTimeoutSet && scrollPosition + windowHeight > documentHeight / 2) {
          if (isSetPopupScrollpage !== 'showed') {
            popups.css('z-index', '1000');
            popupScrollpage.addClass('active');
            setTimeout(function() {
              popupScrollpage.removeClass('active');
              popupScrollpage.remove();
              popups.css('z-index', '-1');
              localStorage.setItem('popupScrollpage', 'showed');
            }, 15000);
            isTimeoutSet = true;
          }
        }
      });
    }
  });
}

scrollPopup();
